import { createContext, useContext, useMemo, type ReactNode } from "react";

interface DemoModeContextValue {
  enabled: boolean;
}

const DemoModeContext = createContext<DemoModeContextValue>({ enabled: false });

export function DemoModeProvider({
  children,
  enabled,
}: {
  children: ReactNode;
  enabled: boolean;
}) {
  const value = useMemo(() => ({ enabled }), [enabled]);
  return <DemoModeContext.Provider value={value}>{children}</DemoModeContext.Provider>;
}

export function useDemoMode(): DemoModeContextValue {
  return useContext(DemoModeContext);
}
